
import { v4 as uuidv4 } from 'uuid';

export const initialFValues = {
  id: uuidv4(),
  Tipologia : {
    tipo: "",
    abbreviazione: ""
  },
  titolo: "",
  acronimo: "",
  Abstract: {
    ita: "",
    eng: ""
  },
  anno_di_avvio: "",
  web: "",
  Parole_Chiave: [
  ],
  Partner: [
  ],
  ruolo_Unifi: "",
  Responsabile: [
  ],
  UNIFI_Team: [
  ],
  Media: [
  ],
};

export const menuTipologia = [
  {id: "PE", tipo: "Progetto europeo"},
  {id: "PN", tipo: "Progetto nazionale"},
  {id: "PNF", tipo: "Progetto nazionale - fondazioni"},
  {id: "PCS", tipo: "Progetto per la cooperazione allo sviluppo"},
  {id: "PR", tipo: "Progetto regionale"},

];

export const initialPartner = {
    nome: "",
    link: ""
};

export const initialTeamMember = {
    nome: "",
    link: ""
};

export const initialMedia = {
    cosa: "",
    link: ""
};


export const initialResponsabile = {
    nome: "",
    link: ""
};

export const myMottos = [
  {
    motto: "“La ricerca è l'atto di percorrere i vicoli per vedere se sono ciechi”",
    autore: "Plutarco"
  },
  {
    motto: "“La scienza dovrebbe rifiutare le teorie e cercare il cigno nero”",
    autore: "Maria Michela Marzano"
  },
  {
    motto: "“La professione del ricercatore deve tornare alla sua tradizione di ricerca per l'amore di scoprire nuove verità”",
    autore: "Enrico Fermi"
  
  },
  {
    motto: "“La ricerca scientifica, benché quasi costantemente guidata dal ragionamento, è pur sempre un'avventura”",
    autore: "Louis de Broglie"
  
  },
  {
    motto: "“Abbandona le grandi strade, prendi i sentieri”",
    autore: "Pitagora"
  
  }
]